import React from 'react';

export default function Maintenance() {
  return (
    <div style={{
      minHeight: '100vh',
      background: 'var(--bg)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2rem',
    }}>
      <div style={{
        background: 'var(--surface)',
        border: '1px solid var(--border)',
        borderRadius: 'var(--radius)',
        boxShadow: 'var(--shadow-lg)',
        padding: '3rem 2.5rem',
        maxWidth: 460,
        width: '100%',
        textAlign: 'center',
      }}>
        {/* Clinic name */}
        <div style={{ marginBottom: '2rem' }}>
          <div style={{
            fontSize: '1.05rem',
            fontWeight: 700,
            color: 'var(--text-1)',
            letterSpacing: '-0.3px',
          }}>
            Heart Team Records
          </div>
          <div style={{
            fontSize: '0.75rem',
            color: 'var(--text-3)',
            marginTop: 2,
            letterSpacing: '0.3px',
          }}>
            Clinic Batch Sorter
          </div>
        </div>

        {/* Lock icon */}
        <div style={{ marginBottom: '1.5rem', display: 'flex', justifyContent: 'center' }}>
          <svg
            width="56"
            height="56"
            viewBox="0 0 24 24"
            fill="none"
            stroke="var(--text-3)"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
            <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
          </svg>
        </div>

        {/* Heading */}
        <h1 style={{
          fontSize: '1.2rem',
          fontWeight: 700,
          color: 'var(--text-1)',
          marginBottom: '0.6rem',
          letterSpacing: '-0.3px',
        }}>
          System Temporarily Unavailable
        </h1>

        {/* Subtext */}
        <p style={{
          fontSize: '0.875rem',
          color: 'var(--text-2)',
          lineHeight: 1.6,
          marginBottom: '2rem',
        }}>
          Please contact your system administrator to restore access.
        </p>

        {/* Divider */}
        <div style={{
          height: 1,
          background: 'var(--border)',
          marginBottom: '1.5rem',
        }} />

        {/* Contact info */}
        <div style={{ textAlign: 'left' }}>
          <div style={{
            fontSize: '0.7rem',
            fontWeight: 600,
            color: 'var(--text-3)',
            textTransform: 'uppercase',
            letterSpacing: '0.08em',
            marginBottom: '0.5rem',
          }}>
            System Administrator
          </div>
          <a
            href="mailto:mabdulhussein@heartteam.com"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.4rem',
              fontSize: '0.875rem',
              color: 'var(--primary)',
              textDecoration: 'none',
              fontWeight: 500,
            }}
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
              <polyline points="22,6 12,13 2,6"/>
            </svg>
            mabdulhussein@heartteam.com
          </a>
        </div>
      </div>
    </div>
  );
}
